import { SvgIcon } from "@/components/SvgIcon";
import { useTranslation } from "react-i18next";
import style from "./index.module.scss";

const EmptyOrder = () => {
  const { t } = useTranslation();
  return (
    <div className={style["empty-content"]} style={{ marginTop: "1.583rem" }}>
      <SvgIcon icon={"icon-wuliebiao"} />
      {t("暂无订单")}
    </div>
  );
};

export default EmptyOrder;
